import { NotificationSettingsList } from "./NotificationSettingsList";

export default NotificationSettingsList;